module.exports = __webpack_public_path__ + "img/vexere_qr.23e6f1ae.png";